import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleButton({ label = "Continuer avec Google" }) {
  const startGoogle = () => {
    const redirectUrl = window.location.origin + "/compte";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button type="button" variant="outline" onClick={startGoogle} className="w-full border-line text-ink rounded-md" data-testid="google-login">
      <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1Z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z"/><path fill="#EA4335" d="M12 4.75c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 1.46 14.97.5 12 .5A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 6.68 9.14 4.75 12 4.75Z"/></svg>
      {label}
    </Button>
  );
}

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <div className="text-center mb-8">
        <p className="font-overline text-terracotta mb-2">Kit Parental</p>
        <h1 className="font-heading text-3xl text-ink tracking-tight">{title}</h1>
        {subtitle && <p className="text-ink-muted mt-2 text-sm">{subtitle}</p>}
      </div>
      <div className="bg-cream border border-line rounded-lg p-7">{children}</div>
      {footer && <div className="text-center text-sm text-ink-muted mt-5">{footer}</div>}
    </div>
  );
}
